
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-orange-500 font-bold text-2xl">POG</span>
              <span className="text-white font-semibold">Professional Office Group</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Leading office furniture dealer in South Carolina, providing comprehensive commercial furniture solutions with expert design, delivery, and installation services.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Home</a></li>
              <li><a href="/about" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">About</a></li>
              <li><a href="/services" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Services</a></li>
              <li><a href="/contact" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Contact</a></li>
              <li><a href="/quote" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">Get Quote</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line text-orange-500"></i>
                <span className="text-gray-300">South Carolina, USA</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-orange-500"></i>
                <span className="text-gray-300">(864) 434-9724</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-orange-500"></i>
                <span className="text-gray-300">rocio@pogsc.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Professional Office Group. All rights reserved.
          </p>
          <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors">
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
